import { selectBuildingsInfoByTypeId } from "../../../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../../../utils/utilBuildings";
import { utilFunction } from "../../../../../utils/utilFunction";
import { createPathFocusBuildingMaxLevel } from "../../../path/createPathFocusBuildingMaxLevel";
export var pathFocusStandardBuildingMaxLevel = function (action, state$, deps) {
    return createPathFocusBuildingMaxLevel(function () {
        var state = state$.value;
        var availableBuildings = selectBuildingsInfoByTypeId(state, action.taskType.buildingId);
        return availableBuildings.filter(utilFunction.negate(utilBuildings.isPremium));
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/paths/pathFocusStandardBuildingMaxLevel.ts
// module id = 2378
// module chunks = 3